'use client';

import { custom_PR_Data } from '@/assets/data/data';
import { Disclaimer1a } from '@/blocks/disclaimer/variants/disclaimer-1a';
import { Button } from '@/components/button';
import { RichText } from '@/components/rich-text';

export const CustomPR = ({
    date,
    press_release,
    type,
    disclaimer,
    pdf,
    locale,
}) => {
    function handlePrint() {
        var press_release_title = document.getElementById(
            'press-release-title'
        ).innerHTML;
        var press_release_body =
            document.getElementById('press-release-body').innerHTML;
        var printWindow = window.open('', '', 'height=500, width=500');
        printWindow.document.write('<html>');
        printWindow.document.write(
            '<style> img {max-width:100%} figure {text-align:center}</style>'
        );
        printWindow.document.write('<body >');
        printWindow.document.write(`<h1>${press_release_title}</h1>`);
        printWindow.document.write(press_release_body);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        return printWindow.print();
    }
    return (
        <section className="section">
            <div className="container">
                <Button
                    className={'info__button mb-6'}
                    icon={'fa-solid fa-arrow-left'}
                    icon_position={'left'}
                    btn_style={'tertiary'}
                    btn_size={pdf?.btn_size}
                    cta_link="newsroom/press-releases"
                >
                    {custom_PR_Data[locale].backButton}
                </Button>
            </div>
            {type === custom_PR_Data[locale]?.global && (
                <div>
                    <Disclaimer1a
                        title={disclaimer.title}
                        description={disclaimer.description}
                        theme={disclaimer.theme}
                    ></Disclaimer1a>{' '}
                    <br />
                </div>
            )}
            <div className="container">
                {date && <div className="article__date">{date}</div>}
                <h2 id="press-release-title">{press_release?.title}</h2>
                <div>
                    <div className="article__tags">
                        <div className="article__tag">{type}</div>
                    </div>
                    {type === custom_PR_Data[locale]?.domestic && pdf && (
                        <Button
                            cta_link={pdf?.cta_link}
                            className={'info__button mr-4'}
                            icon={pdf?.icon}
                            icon_position={pdf?.icon_position}
                            btn_style={pdf?.btn_style}
                            btn_size={pdf?.btn_size}
                        >
                            {pdf?.cta_text}
                        </Button>
                    )}
                    <Button
                        className={'info__button mb-4'}
                        icon={'fa-regular fa-print'}
                        trigger={handlePrint}
                        icon_position={'right'}
                        btn_style={pdf?.btn_style || 'primary'}
                        btn_size={pdf?.btn_size || 'md'}
                    >
                        {custom_PR_Data[locale].printCTA}
                    </Button>
                </div>
                <div id="press-release-body">
                    <RichText
                        className="richtext__press-release"
                        data={press_release.body}
                    />
                </div>
            </div>
        </section>
    );
};
